// extracted by mini-css-extract-plugin
export default {"heroWrapper":"_3fNrydsKt57kNdXPPjCPuf","buttonContainer":"_2SRtgmiFFHDrNEB4iHUT1W","mainImage":"_2KsN4jwaAS1d3xXJFVYCnK","mobileImage":"_1GgELgiPQxXJ3lGlmpGDfl"};